









































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Groups, Global, Schedules } from '@/store';
import { Prop } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';

@Component({ })
class GroupsSelection extends Vue {
    @Groups.State('list') groupList;
    @Global.State('lang') lang;
    @Global.State('readonly_user') readonly_user;
    @Schedules.State('schedules') schedules;

    @Prop() schedule_groups;
    @Prop() schedule_id;

    checkbox_color = '#812E81';
    selected_groups = [];
    search = '';

    mounted(){
        this.selected_groups = [...this.schedule_groups];
    }

    get groups_list(){
        return cloneDeep(this.groupList)
            .filter((group) => group.total_devices > 0)
            .sort((group1, group2) => group1.name.localeCompare(group2.name));
    }

    /**
     * Groups already assigned to other schedules, mapped to every one of those schedules'
     * names, so the picklist can warn before the same group gets scheduled again.
     */
    get scheduled_groups_map(){
        const map = {};
        this.schedules
            .filter((schedule) => schedule.id !== this.schedule_id && schedule.name && Array.isArray(schedule.groups))
            .forEach((schedule) => schedule.groups.forEach((group_id) => {
                if (!map[group_id]) map[group_id] = [];
                if (!map[group_id].includes(schedule.name)) map[group_id].push(schedule.name);
            }));

        return map;
    }

    /** The groups currently matching the search text - what "Select All" applies to. */
    get filtered_groups(){
        const query = (this.search || '').toLowerCase();
        return this.groups_list.filter((group) => group.name.toLowerCase().includes(query));
    }

    get allSelected(){
        return this.filtered_groups.length > 0 && this.filtered_groups.every((group) => this.selected_groups.includes(group.id));
    }

    get someSelected(){
        return !this.allSelected && this.filtered_groups.some((group) => this.selected_groups.includes(group.id));
    }

    handleSelectChanged() {
        this.$emit('selectedGroupsChanged', [...this.selected_groups]);
    }

    handleContinueClicked(){
        this.$emit('stepChanged', 2);
    }

    selectAll() {
        const filtered_ids = this.filtered_groups.map((group) => group.id);

        this.selected_groups = this.allSelected
            ? this.selected_groups.filter((group_id) => !filtered_ids.includes(group_id))
            : [...new Set([...this.selected_groups, ...filtered_ids])];

        this.handleSelectChanged();
    }

}

export default GroupsSelection;
